package tweenx909;

/**
 * ...
 * @author shohei909
 */

class EventX {
    public static inline var PLAY = "play";
    public static inline var DELAY = "delay";
    public static inline var HEAD = "head";
    public static inline var UPDATE = "update";
    public static inline var FOOT = "foot";
    public static inline var INTERVAL = "interval";
    public static inline var REPEAT = "repeat";
    public static inline var REST = "rest";
    public static inline var FINISH = "finish";
    public static inline var STOP = "stop";
}
